import { useCallback, useEffect, useState } from "react";

export function usePepFetch<T>(loader: () => Promise<T>, deps: unknown[] = []) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(() => {
    setLoading(true);
    setError(null);
    return loader()
      .then((value) => {
        setData(value);
        return value;
      })
      .catch((err: unknown) => {
        const message =
          err instanceof Error ? err.message : "Impossible de contacter l'API PEP.";
        setError(message);
        setData(null);
        return null;
      })
      .finally(() => setLoading(false));
  }, [loader]);

  useEffect(() => {
    void reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps contrôlés par l'appelant
  }, deps);

  return { data, loading, error, reload, setData };
}
